import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { useMemo } from 'react';
import toLowerCase from 'utils/toLowerCase';

export interface CountryFlagIconProps {
  region: General.Region | General.UpperCaseRegion;
  size?: number;
  round?: boolean;
  title?: string;
}

export const CountryFlagIcon = (props: CountryFlagIconProps) => {
  const { region, round, size, title } = props;

  const { t } = useTranslate();
  const src = useMemo(() => {
    if (round) {
      return `${process.env.PUBLIC_URL}/country-flag-icons/round/${region?.toUpperCase()}.svg`;
    }

    return `${process.env.PUBLIC_URL}/country-flag-icons/${region?.toUpperCase()}.svg`;
  }, [region, round]);

  return (
    <ImgIcon
      title={title}
      alt={t(`region.${toLowerCase(region)}`)}
      src={src}
      style={size ? { width: `${size}px`, height: `${size}px` } : undefined}
    />
  );
};

const ImgIcon = styled.img`
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 0;
  text-align: center;
  vertical-align: -0.125em;
`;
